module.exports = __webpack_public_path__ + "img/windmill.2deb64f0.png";